import { GenericOptionType } from "@portal/BaseComponents/CheckBox/type";
import { MenuGroup } from "@portal/BaseComponents/Menu/type";
import { PaymentDefaultKeys } from "./type";
import { PageList } from "@portal/types/page-list";

const customerFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Customer",
    key: "Customer",
    children: [],
  },
];
const InvoiceFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Invoice",
    key: "Invoice",
    children: [],
  },
];
const PaymentFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Payments",
    key: "Payment",
    children: [],
  },
];

export const paymentFilterGroups = [
  ...PaymentFilterGroups,
  ...customerFilterGroups,
  ...InvoiceFilterGroups,
];


export function getPaymentModeOptions(paymentModes?:PageList<string, unknown>): GenericOptionType[] {
  return paymentModes?.list?.map((mode) => {
    return { label: mode, value: mode };
  }) || [];
}

export const paymentDefaultKeys: PaymentDefaultKeys[] = [
  "from_date",
  "modes",
  "date_range",
  "to_date",
  "statuses",
];
